import { applyMiddleware, combineReducers, compose, createStore as _createStore, type Reducer } from 'redux';
import { withExtraArgument } from 'redux-thunk';

import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, TReduxActions, IReduxStore, TThunkDispatch } from '../../types/redux';
import { createSimpleReducer } from '../../reducers';
import { ratingReducer } from '../../reducers/rating';
import { filtersReducer } from '../../reducers/filtersReducer';
import { optionsReducer } from '../../reducers/options';

import type { IRegions } from '../../types/regions';

interface IThunkExt {
  dispatch: TThunkDispatch;
}

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(context: IApplicationContext, initialState: IApplicationState, debugEnabled: boolean) {
  const reducers = combineReducers({
    options: optionsReducer,
    rating: ratingReducer,
    filters: filtersReducer,
    regions: createSimpleReducer<IRegions[]>([]),
    regionsForPicker: createSimpleReducer<IRegions[]>([]),
  }) as unknown as Reducer<IApplicationState, TReduxActions>;

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(withExtraArgument(context)));

  const createStore = (): IReduxStore =>
    _createStore<IApplicationState, TReduxActions, IThunkExt>(reducers, initialState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
